angular.module('homebot.directives')

  .directive('pageNotification', ['$rootScope', function($rootScope){
    return {
      restrict: 'E',
      controllerAs: 'pageNotificationCtrl',
      scope: {},
      templateUrl: '/homes/templates/partials/page-notification.html',

      controller: function(){
        var ctrl = this;

        $rootScope.$on('PageNotification', function(event, data){
          if(data.message)
            ctrl.message = data.message;
          else
            ctrl.clear();
        });

        ctrl.clear = function(){
          ctrl.message = '';
        };

      }
    }

  }]);
